<div class="container-fluid" [formGroup]="form">
  <div class="table-container">
    <div class="table-scroll-wrapper">
      <table class="risk-table">
        <thead>
          <tr>
            <td></td>
            <td>Consequence</td>
            <td>Likelihood</td>
            <td>Ranked Score</td>
          </tr>
        </thead>
        <tbody>
          <ng-container formArrayName="scores">
            @for (score of scores.controls; track $index; let i = $index) {
            <tr [formGroup]="score">
              <td>
                <span class="title">{{ score.value.title }}</span>
              </td>
              <td>
                <mat-form-field>
                  <mat-select formControlName="consequence">
                    @for (item of options(); track $index) {
                    <mat-option [value]="item">{{ item }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <mat-select formControlName="likelihood">
                    @for (item of options(); track $index) {
                    <mat-option [value]="item">{{ item }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input matInput type="number" formControlName="rankedScore" readonly />
                </mat-form-field>
              </td>
            </tr>
            }
          </ng-container>
          <tr>
            <td [colSpan]="3">
              <span class="title">High Score</span>
            </td>
            <td>
              <mat-form-field>
                <input matInput formControlName="totalScore" readonly>
              </mat-form-field>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="comments">
    <h5>Comments</h5>

    <div class="horizontal-form-field">
      <label class="form-label">{{displayNames["healthAndSafetyComment"]}}</label>
      <div class="full-width">
        <div class="control-col">
          <angular-editor [id]="'healthAndSafetyComment'" formControlName="healthAndSafetyComment" [config]="configHealthSafety"></angular-editor>
          <mat-error *ngIf="getErrorMessage('healthAndSafetyComment') as errorMessage">{{ errorMessage }}</mat-error>
        </div>
      </div>
    </div>
    <div class="horizontal-form-field">
      <label class="form-label">{{displayNames["environmentalComment"]}}</label>
      <div class="full-width">
        <div class="control-col">
          <angular-editor [id]="'environmentalComment'" formControlName="environmentalComment" [config]="configEnvironmental"></angular-editor>
          <mat-error *ngIf="getErrorMessage('environmentalComment') as errorMessage">{{ errorMessage }}</mat-error>
        </div>
      </div>
    </div>
    <div class="horizontal-form-field">
      <label class="form-label">{{displayNames["reputationComment"]}}</label>
      <div class="full-width">
        <div class="control-col">
          <angular-editor [id]="'reputationComment'" formControlName="reputationComment" [config]="configReputation"></angular-editor>
          <mat-error *ngIf="getErrorMessage('reputationComment') as errorMessage">{{ errorMessage }}</mat-error>
        </div>
      </div>
    </div>
    <div class="horizontal-form-field">
      <label class="form-label">{{displayNames["assetComment"]}}</label>
      <div class="full-width">
        <div class="control-col">
          <angular-editor [id]="'assetComment'" formControlName="assetComment" [config]="configAsset"></angular-editor>
          <mat-error *ngIf="getErrorMessage('assetComment') as errorMessage">{{ errorMessage }}</mat-error>
        </div>
      </div>
    </div>
    <div class="horizontal-form-field">
      <label class="form-label">{{displayNames["riskAssessmentComments"]}}</label>
      <div class="full-width">
        <div class="control-col">
          <angular-editor [id]="'riskAssessmentComments'" formControlName="riskAssessmentComments" [config]="configRiskAssessment"></angular-editor>
          <mat-error *ngIf="getErrorMessage('riskAssessmentComments') as errorMessage">{{ errorMessage }}</mat-error>
        </div>
      </div>
    </div>

    <div class="form-field">
      <app-file-upload label="Attach Risk Evaluation form" [fileName]="path.value" (changed)="getFile($event)"
        (download)="download()" (delete)="removeFile()" />
    </div>
  </div>
</div>
